import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

function TasksMenu(props) {
  const { filmId } = props.match.params;
  const { canViewTaskStatuses } = props;

  if (!canViewTaskStatuses) {
    return null;
  }

  return (
    <div className="blade-menu menu">
      <p className="menu-label">Tasks</p>
      <ul className="menu-list">
        <li>
          <NavLink
            to={`/films/${filmId}/tasks`}
            activeClassName="is-active">
            Board
          </NavLink>
        </li>

        <li>
          <NavLink
            to={`/films/${filmId}/task-statuses`}
            activeClassName="is-active">
            Statuses
          </NavLink>
        </li>

      </ul>
    </div>
  );
}

function mapStateToProps(state) {
  const { tasksState } = state;
  return {
    canViewTaskStatuses: tasksState.canViewTaskStatuses
  };
}

export default connect(mapStateToProps, {
})(TasksMenu);

